import React from 'react';
import _ from 'lodash';
import {Map} from 'immutable';
import shallowCompare from '../../lib/shallowCompare';
import Address from '../../models/Address';
import AddressSearch from '../AddressSearch';
import styles from './index.sass';
import Modal from '../../../client/components/Modal';
import CustomerActions from '../../actions/CustomerActions';
import {isMobileOrTablet} from '../../../client/lib/utils';
import menuClosePng from '../images/button_menu_close.png';
import menuCloseSvg from '../images/button_menu_close.svg';

export const Modes = {
  Add: 'add',
  Edit: 'edit',
  Select: 'select'
};
const InputStates = {
  Empty: 'empty',
  Invalid: 'invalid',
  Valid: 'valid'
};

class ShippingAddressModal extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func
  };

  static propTypes = {
    selectedShippingAddressId: React.PropTypes.string,
    shippingAddresses: React.PropTypes.object,
    billingAddress: React.PropTypes.object,
    storeId: React.PropTypes.string, // Optional: Indicates whether or not an update to shopping cart will be made
    defaultName: React.PropTypes.string,
    mode: React.PropTypes.string,
    onCancel: React.PropTypes.func.isRequired,
    onSave: React.PropTypes.func.isRequired,
    onRemove: React.PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
  }

  getStateFromProps(props) {
    let mode = props.mode ? props.mode : Modes.Select;
    let address;
    if(mode === Modes.Edit && props.selectedShippingAddressId) {
      address = props.shippingAddresses.find((sa) => {return sa.id === props.selectedShippingAddressId;});
    } else {
      address = new Address({name: props.defaultName ? props.defaultName : null});
    }
    return {
      error: null,
      loading: false,
      mode: mode,
      selectedShippingAddressId: props.selectedShippingAddressId,
      addressSearchSuggestsVisible : false,
      billingAddress: props.billingAddress,
      address: address,
      addressState: new Map({
        name: InputStates.Empty,
        addr1: InputStates.Empty,
        addr2: InputStates.Empty,
        city: InputStates.Empty,
        state: InputStates.Empty,
        zip_code: InputStates.Empty
      })
    };
  }

  trackViewEvent() {
    let value = this.state.mode === Modes.Select ? 'address_select' : 'address_enter';
    if(this.state.addressSearchSuggestsVisible) {
      value = 'address_search';
    }
    if(this.props.storeId) {
      value = `checkout_${value}`;
    }
    this.context.trackEvent('view', {value});
  }

  componentDidMount() {
    this.trackViewEvent();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
    // Auto-select most recently added
    // if(nextProps.shippingAddresses.size > this.props.shippingAddresses.size) {
    //   this.handleOnChangeShippingAddress(nextProps.shippingAddresses.get(0).id);
    // }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.mode !== this.state.mode) {
      this.trackViewEvent();
    }
  }

  handleOnChangeShippingAddress(id) {
    if(id === this.state.selectedShippingAddressId) {return;}
    this.setState({selectedShippingAddressId: id});
    this.props.onSave({shippingAddressId: id});
  }

  handleOnChangeShippingAddressInput(field, e) {
    let value = normalizeValue(field, e.target.value);
    let state = validateField(field, value);
    let addressUpdates = {};
    let addressStateUpdates = {};

    addressUpdates[field] = value;
    addressStateUpdates[field] = state;
    this.setState({
      address: this.state.address.merge(addressUpdates),
      addressState: this.state.addressState.merge(addressStateUpdates)
    });
  }

  handleOnChangeSuggestsAddressSearch(suggestsVisible) {
    this.setState({addressSearchSuggestsVisible : !!suggestsVisible});
    this.context.trackEvent('address_search');
  }

  handleOnSelectSearchSuggest(data) {
    let address = {};
    let addressState = {};
    let streetNumber = '';
    let streetName = '';
    data.gmaps.address_components.forEach(component => {
      if(-1 !== component.types.indexOf('street_number')) {
        streetNumber = component.long_name;
      } else if(-1 !== component.types.indexOf('route')) {
        streetName = component.long_name;
      } else if(-1 !== component.types.indexOf('locality') || -1 !== component.types.indexOf('sublocality')) {
        address.city = component.long_name;
        addressState.city = InputStates.Valid;
      } else if(-1 !== component.types.indexOf('administrative_area_level_1')) {
        address.state = component.short_name;
        addressState.state = InputStates.Valid;
      } else if(-1 !== component.types.indexOf('postal_code')) {
        address.zip_code = component.short_name;
        addressState.zip_code = InputStates.Valid;
      }
    });
    address.addr1 = _.trim(`${streetNumber} ${streetName}`);
    addressState.addr1 = InputStates.Valid;

    this.setState({
      address: new Address(address),
      addressState: new Map(addressState),
      mode: Modes.Add
    });
    this.context.trackEvent('select_suggested_address');
  }

  handleOnClickNewShippingAddressButton(e) {
    this.setState({mode: Modes.Add});
  }

  handleOnClickContinueButton(e) {
    if(this.state.mode === Modes.Add || this.state.mode === Modes.Edit) {
      let firstInvalidField = null;
      // Required fields
      ['name', 'addr1', 'city', 'state', 'zip_code'].forEach((field) => {
        let val = this.state.address.get(field);
        let state = validateField(field, val);
        if(state === InputStates.Invalid && !firstInvalidField) {
          firstInvalidField = field;
        }
      });
      if(firstInvalidField) {
        return this.setState({addressState: this.state.addressState.set(firstInvalidField, InputStates.Invalid)});
      }
      let address = this.state.address.toJS();
      this.setState({loading : true});
      let payload = {address};
      if(this.state.mode === Modes.Add) {
        if(this.props.storeId) {
          payload.store_id = this.props.storeId;
        }
        this.context.executeAction(CustomerActions.addShippingAddress, payload);
      } else {
        this.context.executeAction(CustomerActions.updateShippingAddress, payload);
      }
      this.props.onSave();
    }
  }

  handleOnClickEnterManuallyButton(e) {
    this.setState({mode: Modes.Add});
  }

  handleOnClickEditButton(id, e) {
    e.stopPropagation();
    e.preventDefault();

    let address = this.props.shippingAddresses.find((sa) => {return sa.id === id;});
    let addressState = {};
    address.forEach((val, field) => {
      addressState[field] = validateField(field, val);
    });
    this.setState({
      address: address,
      addressState: new Map(addressState),
      mode: Modes.Edit
    });
  }

  handleOnClickRemoveButton(e) {
    if(this.state.mode !== Modes.Edit) {return;}
    this.setState({loading : true});
    this.context.executeAction(CustomerActions.removeShippingAddress, {address_id: this.state.address.id});
    this.props.onRemove(this.state.address.id);
  }

  handleOnCloseModal() {
    this.props.onCancel();
  }

  handleOnClickSameAsBillingAddressButton(e) {
    this.setState({mode: Modes.Add, address: this.state.address.merge(this.state.billingAddress)});
  }

  renderContinueButton() {
    if(this.state.mode === Modes.Select) {return null;}
    let disabled = this.state.loading || !!this.state.addressState.find((val, field) => {return val === InputStates.Invalid;});
    let continueButtonProps = {
      className : styles.continueButton,
      disabled  : disabled,
      onClick   : this.handleOnClickContinueButton.bind(this)
    };
    let buttonText = 'Submit';
    if(this.state.loading) {
      buttonText = <span className="loading-spinner--white" />;
    } else if(this.state.mode === Modes.Edit) {
      buttonText = 'Update';
    }
    return <button {...continueButtonProps}>{buttonText}</button>;
  }

  renderRemoveButton() {
    if(this.state.mode !== Modes.Edit) {return null;}
    let removeButtonProps = {
      className: styles.removeButton,
      onClick: this.handleOnClickRemoveButton.bind(this)
    };
    return <button {...removeButtonProps}>Remove shipping address</button>;
  }

  renderError() {
    if(!this.state.error) {return null;}
    return <span className={styles.error}>{this.state.error}</span>;
  }

  renderShippingAddressSearch() {
    if(this.state.mode !== Modes.Select) {return null;}
    let addressSearchProps = {
      placeholder      : 'Enter your address, i.e. 100 Main St',
      count            : 'us',
      autoFocus        : !this.props.shippingAddresses.size,
      onSuggestSelect  : this.handleOnSelectSearchSuggest.bind(this),
      onChangeSuggests : this.handleOnChangeSuggestsAddressSearch.bind(this)
    };
    return <AddressSearch {...addressSearchProps} />;
  }

  renderEnterAddressManuallyButton() {
    if(this.state.mode !== Modes.Select || this.props.shippingAddresses.size || this.state.addressSearchSuggestsVisible) {return null;}
    let manualLinkProps = {
      onClick: this.handleOnClickEnterManuallyButton.bind(this)
    };
    return (
      <div className={styles.enterManuallySection}>
        <p>or</p>
        <button {...manualLinkProps}>Enter shipping manually</button>
      </div>
    );
  }

  renderSameAsBillingAddressButton() {
    if(this.state.mode !== Modes.Select || this.props.shippingAddresses.size || this.state.addressSearchSuggestsVisible) {return null;}
    let billingAddressValid = true;
    ['name', 'addr1', 'city', 'state', 'zip_code'].forEach((field) => {
      let val = this.state.billingAddress[field];
      let state = validateField(field, val);
      if(state === InputStates.Invalid) {
        billingAddressValid = false;
      }
    });
    if (!billingAddressValid) {
      return null;
    }
    let manualLinkProps = {
      onClick: this.handleOnClickSameAsBillingAddressButton.bind(this)
    };
    return (
      <div className={styles.enterManuallySection}>
        <p>or</p>
        <button {...manualLinkProps}>Same as Billing Address</button>
      </div>
    );
  }

  renderShippingAddresses(shippingAddresses) {
    if(this.state.mode !== Modes.Select || this.state.addressSearchSuggestsVisible) {return null;}
    let selectedShippingAddressId = this.state.selectedShippingAddressId;
    return shippingAddresses.map(shippingAddress => {
      let id = shippingAddress.id;
      let shippingAddressButtonProps = {
        key           : id,
        className     : styles.shippingAddressButton
      };
      let shippingAddressProps = {
        className     : styles.shippingAddress,
        shippingAddress : shippingAddress
      };
      let inputProps = {
        className     : styles.checkbox,
        type          : 'checkbox',
        name          : id,
        id            : id,
        checked       : selectedShippingAddressId === id,
        onChange      : this.handleOnChangeShippingAddress.bind(this, id)
      };
      let labelProps = {
        className     : styles.checkboxLabel,
        htmlFor       : id
      };
      let editShippingAddressButtonProps = {
        className     : styles.editShippingAddressButton,
        onClick       : this.handleOnClickEditButton.bind(this, id)
      };
      let name = shippingAddress.name ? <span>{shippingAddress.name}</span> : null;
      return (
        <div {...shippingAddressButtonProps}>
          <input {...inputProps} />
          <label {...labelProps}>
            {name}
            <span>{shippingAddress.addr1} {shippingAddress.addr2}</span>
            <span>{shippingAddress.city}, {shippingAddress.state} {shippingAddress.zip_code}</span>
          </label>
          <button {...editShippingAddressButtonProps}>Edit</button>
        </div>
      );
    });
  }

  renderForm() {
    if(this.state.mode === Modes.Select) {return null;}
    let isMobile = isMobileOrTablet();
    let { address, addressState } = this.state;

    let nameInputProps = {
      type        : 'text',
      autoFocus   : true,
      autoComplete: 'name',
      className   : styles.input + (addressState.get('name') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Full name',
      value       : address.name,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'name')
    };
    let addr1InputProps = {
      type        : 'text',
      autoComplete: 'address-line1',
      className   : styles.input + (addressState.get('addr1') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Address',
      value       : address.addr1,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'addr1')
    };
    let addr2InputProps = {
      type        : 'text',
      autoComplete: 'address-line2',
      className   : styles.input + (addressState.get('addr2') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Apt/Suite (optional)',
      value       : address.addr2,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'addr2')
    };
    let cityInputProps = {
      type        : 'text',
      autoComplete: 'address-level2',
      className   : styles.input + (addressState.get('city') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'City',
      value       : address.city,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'city')
    };
    let stateInputProps = {
      type        : 'text',
      autoComplete: 'address-level1',
      className   : styles.halfInput + (addressState.get('state') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'State',
      value       : address.state,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'state')
    };
    let zipCodeInputProps = {
      type        : 'text',
      autoComplete: 'postal-code',
      className   : styles.halfInput + (addressState.get('zip_code') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Zip code',
      value       : address.zip_code,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'zip_code')
    };
    return (
      <div className={styles.form}>
        {this.renderError()}
        <div className={styles.inputContainer}>
          <input {...nameInputProps} />
          <input {...addr1InputProps} />
          <input {...addr2InputProps} />
          <input {...cityInputProps} />
          <input {...stateInputProps} />
          <input {...zipCodeInputProps} />
        </div>
      </div>
    );
  }

  render() {
    let modalProps = {
      className: styles.shippingAddressModal,
      closeOnOutsideClick: true,
      onClose: this.handleOnCloseModal.bind(this)
    };
    let header = this.state.mode === Modes.Edit ? 'Edit shipping address' : 'Shipping address';
    return (
      <Modal {...modalProps}>
        <div className={styles.shippingAddressModalContents}>
          <button className={styles.closeButton} onClick={this.handleOnCloseModal.bind(this)}>
            <img src={menuClosePng} srcSet={menuCloseSvg} />
          </button>
          <h2 className={styles.header}>{header}</h2>
          <div>
            {this.renderShippingAddressSearch()}
            {this.renderEnterAddressManuallyButton()}
            {this.renderSameAsBillingAddressButton()}
            {this.renderShippingAddresses(this.props.shippingAddresses)}
            {this.renderForm()}
          </div>
          {this.renderContinueButton()}
          {this.renderRemoveButton()}
        </div>
      </Modal>
    );
  }
}

export default ShippingAddressModal;

function normalizeValue(field, value) {
  switch(field) {
    case 'state':
      value = value.replace(/[^A-z]/g, '').slice(0, 2).toUpperCase();
      break;
    case 'zip_code':
      value = value.replace(/\D/g, '');
      break;
    case 'addr1':
    case 'name':
    case 'addr2':
    case 'city':
    default:
      break;
  }
  return value || '';
}

function validateField(field, value) {
  value = value || '';
  let state;
  switch(field) {
    case 'name':
    case 'addr1':
    case 'city':
      state = value.length ? InputStates.Valid : InputStates.Invalid;
      break;
    case 'state':
      state = (value.length === 2 && STATE_ABBREVIATION_MAP[value]) ? InputStates.Valid : InputStates.Invalid;
      break;
    case 'zip_code':
      state = value.length >= 5 ? InputStates.Valid : InputStates.Invalid;
      break;
    default:
      break;
  }
  return state;
}

const STATE_NAME_MAP = {
  'alabama': 'AL',
  'alaska': 'AK',
  'arizona': 'AZ',
  'arkansas': 'AR',
  'california': 'CA',
  'colorado': 'CO',
  'connecticut': 'CT',
  'delaware': 'DE',
  'district of columbia': 'DC',
  'washington d.c.': 'DC',
  'washington dc': 'DC',
  'florida': 'FL',
  'georgia': 'GA',
  'hawaii': 'HI',
  'idaho': 'ID',
  'illinois': 'IL',
  'indiana': 'IN',
  'iowa': 'IA',
  'kansas': 'KS',
  'kentucky': 'KY',
  'louisiana': 'LA',
  'maine': 'ME',
  'maryland': 'MD',
  'massachusetts': 'MA',
  'michigan': 'MI',
  'minnesota': 'MN',
  'mississippi': 'MS',
  'missouri': 'MO',
  'montana': 'MT',
  'nebraska': 'NE',
  'nevada': 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  'ohio': 'OH',
  'oklahoma': 'OK',
  'oregon': 'OR',
  'pennsylvania': 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  'tennessee': 'TN',
  'texas': 'TX',
  'utah': 'UT',
  'vermont': 'VT',
  'virginia': 'VA',
  'washington': 'WA',
  'west virginia': 'WV',
  'wisconsin': 'WI',
  'wyoming': 'WY'
};

const STATE_ABBREVIATION_MAP = _.invert(STATE_NAME_MAP);



// WEBPACK FOOTER //
// banquet/components/ShippingAddressModal/index.js